module.exports = __webpack_public_path__ + "images/application/team/dana-b7293c13.jpg";